import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950 font-heading font-bold text-lg">
                希
              </span>
              <div className="flex flex-col leading-tight">
                <span className="font-heading font-bold text-lg text-background-50">希岛爱理</span>
                <span className="text-xs tracking-[0.25em] text-background-400 uppercase">
                  Film Archive
                </span>
              </div>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              一个专注整理希岛爱理影视作品、动态资讯与角色解析的内容平台，帮助影迷更系统地了解每一部作品与每一个角色。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              内容导航
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/works" className="text-background-300 hover:text-accent-400 transition-colors">
                  影视作品
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-background-300 hover:text-accent-400 transition-colors">
                  动态资讯
                </Link>
              </li>
              <li>
                <Link to="/characters" className="text-background-300 hover:text-accent-400 transition-colors">
                  角色解析
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 hover:text-accent-400 transition-colors">
                  关于本站
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                contact@kirishima-airi.fans
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-information-line text-accent-400" />
                内容更正与投稿欢迎来信
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 希岛爱理影视内容站 · 本站为非官方影迷内容整理平台</p>
          <p>页面资料以演示数据呈现，仅供内容展示</p>
        </div>
      </div>
    </footer>
  );
}